@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           type="text"
           [placeholder]="selectedCount > 0 ? selectedCount + ' Gebäude ausgewählt' : 'Gebäude auswählen'"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [(ngModel)]="filterText"
           [placeholder]="selectedCount > 0 ? selectedCount + ' Gebäude ausgewählt' : 'Gebäude suchen'"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth />
    @if (selectedCount > 0) {
      <button nbSuffix nbButton ghost (click)="onClear()">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    }
  </nb-form-field>
}

<ng-template #popoverTemplate>
  <div class="autocomplete-dropdown">
    <nb-list nbInfiniteList (bottomThreshold)="loadMore()" [threshold]="50" [throttleTime]="100">
      @for (building of buildings(); track building.id) {
        <nb-list-item>
          <nb-checkbox class="building"
                       [checked]="isSelected(building.id)"
                       (checkedChange)="toggle(building.id)">
            <div class="title-and-subtitle">
              <div class="title">{{ building.baseData.sectionText }}</div>
              <div class="subtitle">
                <div class="value">
                  <nb-icon icon="hash" pack="eva"></nb-icon>
                  {{ building.internalNumber }}
                </div>
                <div class="value">
                  <nb-icon icon="globe-outline" pack="eva"></nb-icon>
                  {{ building.ownerTenant.name }}
                </div>
              </div>
            </div>
          </nb-checkbox>
        </nb-list-item>
      }
      @if (buildings().length === 0) {
        <nb-list-item>
          <div class="building-empty">Keine Gebäude gefunden.</div>
        </nb-list-item>
      }
    </nb-list>
  </div>
</ng-template>
